export default __webpack_public_path__ + "static/media/040-stop.608410cb.png";